import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCooperativeId } from 'hooks';
import { ReservationServiceView, ReservationServiceResourceView } from 'models';
import services from 'services';
import { setServiceResource } from 'store/services/action-creators';

import { ServiceDetails } from 'components';

interface ServicesState {
  reservationServices: ReservationServiceView[];
  loading: boolean;
  error: boolean;
}

const Services = () => {
  const dispatch = useDispatch();
  const coopId = useCooperativeId();
  const [state, setState] = useState<ServicesState>({
    reservationServices: [],
    loading: true,
    error: false,
  });

  useEffect(() => {
    fetchReservationServices();
  }, [coopId]);

  const fetchReservationServices = async () => {
    try {
      const reservationServices: ReservationServiceView[] = (
        await services.get(`/api/cooperatives/${coopId}/services`)
      ).data.Data;

      setState((prevState) => ({
        ...prevState,
        reservationServices,
        loading: false,
      }));
    } catch (err) {
      console.error(err);
      setState((prevState) => ({ ...prevState, error: true, loading: false }));
    }
  };

  const selectServiceResource = useCallback(
    (
      resource: ReservationServiceResourceView | null,
      serviceId: string | null,
      slotDuration: number | null
    ) => {
      dispatch(setServiceResource(resource, serviceId, slotDuration));
    },
    [dispatch]
  );

  return (
    <ServiceDetails {...state} selectServiceResource={selectServiceResource} />
  );
};

export default Services;
